 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"750c4d83c98cb78fa2bdaed51f4b05b07a3d4fa7","1":"73e487faf1e0bb67315fdfb7e4b13f83d3b5ed1d","3":"39995e36e95ad6089e5c411809c3a0f2ebbdf31d","4":"1626f6274777c12f1f66c44c23919e1155819fc2","5":"94e11982d2a560fb1571886e0282c097785764a5","6":"85fdd81d9ec6349b571ce88c760702195ad27ca1","7":"0f31a18803a5460e55e664bd37fef2238852bb6c","8":"3cbb10b4ddb43afa621df1cfc6c3da6a137b2183","9":"8a89c4ee03a262fe0f2f50134eb6686cd65166f8","12":"component---src-pages-about-us-js","13":"component---src-pages-big-data-analysis-startup-js","14":"component---src-pages-blog-details-js","15":"component---src-pages-blog-js","16":"component---src-pages-case-studies-details-js","17":"component---src-pages-case-studies-js","18":"component---src-pages-coming-soon-js","19":"component---src-pages-contact-js","20":"component---src-pages-course-details-js","21":"component---src-pages-courses-js","22":"component---src-pages-data-analytics-ai-startup-js","23":"component---src-pages-data-analytics-ml-consulting-js","24":"component---src-pages-data-science-ml-company-js","25":"component---src-pages-data-science-online-courses-js","26":"component---src-pages-digital-marketing-agency-js","27":"component---src-pages-event-details-js","28":"component---src-pages-events-js","29":"component---src-pages-faq-js","30":"component---src-pages-gallery-js","31":"component---src-pages-history-js","32":"component---src-pages-index-js","33":"component---src-pages-machine-learning-ai-solutions-js","34":"component---src-pages-membership-levels-js","35":"component---src-pages-privacy-policy-js","36":"component---src-pages-profile-authentication-js","37":"component---src-pages-seo-agency-js","38":"component---src-pages-service-details-js","39":"component---src-pages-services-js","40":"component---src-pages-team-js","41":"component---src-pages-terms-of-service-js","42":"component---src-pages-testimonials-js"}[chunkId]||chunkId) + "-" + {"0":"8c50abc7f41bcf91e963","1":"1b35d5419b66124ffeef","2":"d6dc9ff6ea461fee6054","3":"778185973797b39cf6bb","4":"760f0773dfda73ce2bab","5":"3a592cc9376da50c490c","6":"678ec4c18f650e63bd2e","7":"a3150e57e955d17a1638","8":"c3a08726039ff382e14e","9":"fdc67645272aba0637a7","12":"2709a05bfece8f9932f6","13":"68bf7e5b8d104907b760","14":"54e1d3730a9aa3547b0c","15":"5a300e700611c948b42a","16":"09649736833925b539df","17":"af4db6cfa436643762b9","18":"26cccda0b1cfcc15c657","19":"f690f277cba3f57a35f8","20":"c85e9450d2e7c59b9cfb","21":"055df08e89b128d51bd1","22":"d86a13a6b4587719b564","23":"0d004327376f33a95c30","24":"775aa3904574ff19966f","25":"f840b6d267854bbaf7f1","26":"cac0cc0f4f154f2590b7","27":"1040ad2d322c4eaad2f5","28":"b2b54b59400da658ea1a","29":"beb18acfcde9693929e1","30":"271719ba955c744f6407","31":"7c6f49a26dc332d14556","32":"e3981a84747d092ac52b","33":"0fe2d60571b5e53ef353","34":"36bb6d3a61463f491532","35":"c8a3ed765f881d5fecef","36":"8ace7d79b5ea3cc9e6c3","37":"70ef97e32ec264718378","38":"f3889c6e60e674457d82","39":"06dd8ee0d599ea13d9b5","40":"c65837933a577e297634","41":"651e9beb0f1cee2b9f33","42":"250a7567108cf4b74c5f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
